<template>
  <div v-if="$store.state.menu.Moderators">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card
            color="green"
            title="Пользователи CRM"
            text="Все пользоватли"
          >
            <v-btn class="mr-2" color="success" @click="openItem(null)" text
              >Добавить</v-btn
            >

            <v-btn color="primary" @click="getModerators(false)" text
              >Обновить</v-btn
            >
            <div class="mt-2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск..."
                class="sticky search"
                :loading="loadingSearch"
                single-line
                hide-details
                clearable="true"
              ></v-text-field>
            </div>
            <v-data-table
              :headers="headers"
              :items="moderatorList"
              hide-actions
            >
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="{ item }">
                <td class="text-xs-left">{{ item.id }}</td>
                <td class="text-xs-left min-width">{{ item.name }}</td>
                <td class="text-xs-left min-width">{{ item.email }}</td>
                <td class="text-xs-right min-width100">
                  <template>
                    <v-icon class="mr-3" @click="openItem(item.id)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon
                      class="mr-2 text-danger"
                      @click="removeItem(item.id)"
                      >mdi-close</v-icon
                    >
                  </template>
                </td>
              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      width="800"
      v-if="currentAdministrator"
      v-model="currentAdministrator"
    >
      <v-card class="pl-5 pr-5 pt-5 pb-4">
        <v-layout wrap>
          <v-flex sm12 xs12>
            <Loader :loading="loadingUpdate" :absolute="true" />
            <div class="body-2 mb-3 mt-2">Разделы меню</div>
            <multiselect
              v-if="menus.length"
              v-model="administrator.menu"
              tag-placeholder="Выберете или напишите новый"
              selectedLabel="Применен"
              placeholder="Ресурс"
              :showLabels="false"
              label="name"
              track-by="id"
              :options="menus"
              :taggable="false"
              :multiple="true"
              class="mb-4"
            ></multiselect>

            <div class="body-2 mb-3 mt-2">Ограниченный фунционал</div>
            <multiselect
              v-if="roles.length"
              v-model="administrator.role"
              tag-placeholder="Выберете или напишите новый"
              selectedLabel="Применен"
              placeholder="Ресурс"
              :showLabels="false"
              label="title"
              track-by="id"
              :options="roles"
              :taggable="false"
              :multiple="true"
              class="mb-4"
            ></multiselect>

            <div class="body-2 mb-3 mt-2">
              Ограничение по выбранным вендорам (активации)
            </div>
            <multiselect
              v-if="brands.length"
              v-model="administrator.brand"
              tag-placeholder="Выберете или напишите новый"
              selectedLabel="Применен"
              placeholder="Вендоры"
              :showLabels="false"
              label="title"
              track-by="id"
              :options="brands"
              :taggable="false"
              :multiple="true"
              class="mb-4"
            ></multiselect>
            <Br />
            <div class="body-2">Имя и фамилия</div>
            <v-text-field v-model="administrator.name"></v-text-field>
            <br />
            <div class="body-2">Email</div>
            <v-text-field v-model="administrator.email"></v-text-field>
            <br />
            <div class="body-2">Пароль</div>
            <v-text-field type="password" v-model="password"></v-text-field>
            <br />
            <div class="text-xs-center">
              <v-btn
                color="success"
                right
                @click="updateItem"
                v-bind:disabled="loading"
                text
                >Сохранить</v-btn
              >
              <v-btn @click="currentAdministrator = null" color="warning" text
                >Закрыть</v-btn
              >
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <Dealer />
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";
import Dealer from "../components/core/Dealer";
import Purchases from "../components/core/Orders/Purchases";
import { mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    password: null,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    loadingUpdate: false,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "id",
      },
      {
        sortable: false,
        text: "Пользователь",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Email",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "",
        value: "",
        align: "right",
      },
    ],
    moderatorList: [],
    administratorID: null,
    currentAdministrator: null,
    administrator: null,
    menus: [],
    roles: [],
  }),
  components: { Purchases, Loader, Dealer },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getModerators();
      }
    },
    getMenus() {
      this.loading = true;
      axios
        .get("admin/administrators/menu")
        .then((response) => {
          this.menus = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.getRoles();
          this.getModerators(false);
        });
    },
    getRoles() {
      axios
        .get("admin/administrators/role")
        .then((response) => {
          this.roles = response.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    getModerators(noLoading) {
      if (!noLoading) this.loading = true;
      axios
        .get("admin/administrators/list", {
          params: {
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.moderatorList = response.data.data;
          this.last_page = response.data.last_page;

          this.currentAdministrator = null;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
          this.loadingSearch = false;
        });
    },
    openItem(administratorID) {
      if (!administratorID) {
        this.administratorID = null;

        this.currentAdministrator = this.administrator = {
          id: this.administratorID,
          menu: [],
          role: [],
          brand: [],
          name: "",
          email: "",
          password: "",
        };
      } else {
        this.administratorID = administratorID;
        this.currentAdministrator = this.moderatorList.filter(
          (x) => x.id == this.administratorID
        )[0];
        this.administrator = this.currentAdministrator;
      }
    },

    removeItem(itemID) {
      if (itemID) {
        this.$dialog
          .confirm("Вы точно хотите удалить?", {
            okText: "Удалить",
            cancelText: "Отмена",
          })
          .then(() => {
            this.loading = true;
            axios
              .delete("admin/administrators/remove", {
                data: {
                  id: itemID,
                },
              })
              .then((response) => {
                this.getModerators();

                this.$toast.success({
                  title: "Удаление",
                  message: "Модератор удален с сервера",
                });
              })
              .catch((error) => {
                this.$toast.error({
                  title: "Удаление",
                  message: "Ошибка удаления",
                });
              })
              .finally(() => {
                this.loading = false;
                this.getItems();
              });
          })
          .catch(() => {});
      }
    },

    updateItem() {
      this.loadingUpdate = true;

      if (this.password) {
        this.administrator.password = this.password;
      }

      axios
        .post("admin/administrators/set", this.administrator)
        .then((response) => {
          this.$toast.success({
            title: "Пользователь",
            message: "Успешно обновили пользователя",
          });

          this.getModerators();
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.password = null;
          this.loadingUpdate = false;
        });
    },
  },

  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getModerators(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getModerators();
      }, 300);
    },
  },

  computed: {
    ...mapState(["brands"]),
  },
  mounted() {
    this.getMenus();
  },
};
</script>
